<div class="sms-verification-dialog">
  <si-generic-dialog [(displayDialog)]="displayDialog"
                     (displayDialogChange)="onChangeDisplayDialog($event)"
                     dialogTitle="SI_IDENTITY_VERIFICATION"
                     dialogImg="assets/images/second-validation.svg"
                     [dialogText]="'SI_IDENTITY_VERIFICATION_SMS_INFO' | translate: {phone: phoneValue?.slice(-3)}"
                     [closable]="false"
                     button1Text="SI_VALIDATE"
                     button1Class="si-button_main"
                     [button1Close]="false"
                     [button1Disabled]="smsVerificationForm?.invalid"
                     button2Text="SI_CANCEL"
                     button2Class="si-button_secondary"
                     (updateButton1Change)="onClickValidate()">
    <div class="mt-3">
      <form #smsVerificationForm="ngForm"
            id="smsVerificationForm"
            name="smsVerificationForm">
        <div>
          <si-input id="smsVerificationCode"
                    name="smsVerificationCode"
                    text="SI_CODE"
                    placeholder="SI_WRITE_HERE"
                    [(model)]="smsVerificationCode"
                    [autoFocus]="true"
                    rule="generic.fieldNotNull"
                    [validationExternalErrorText]="smsVerificationErrorText"
          ></si-input>
        </div>
      </form>
    </div>
  </si-generic-dialog>
</div>
